import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpModalService } from './help-modal.service';
import { HelpModalComponent } from './help-modal.component';
import { TranslateModule } from '@ngx-translate/core';
// import { NgxMdModule } from 'ngx-md';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [HelpModalComponent],
  exports: [HelpModalComponent],
  imports: [
    CommonModule,
    // NgxMdModule.forRoot(),
    TranslateModule,
    MarkdownModule.forRoot(),
  ],
  providers: [HelpModalService],
})
export class HelpModalModule {}
